// extracted by mini-css-extract-plugin
module.exports = {"componentsBankCardTypePrompt":"styles_componentsBankCardTypePrompt__EGo5r"};